export const AtlassianAdministrationLogoInverse = () => (
  <svg
    width="591"
    height="48"
    viewBox="0 0 591 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2305_6798)">
      <path
        d="M10.2888 19.9999C9.78879 19.3999 8.98879 19.4999 8.58879 20.1999L0.0887871 37.1999C-0.211213 37.7999 0.288787 38.5999 0.988787 38.5999H12.7888C13.1888 38.5999 13.4888 38.3999 13.6888 37.9999C16.2888 32.7999 14.6888 24.7999 10.2888 19.9999Z"
        fill="url(#paint0_linear_2305_6798)"
      />
      <path
        d="M16.4888 4.6C11.7888 12.1 12.0888 20.4 15.1888 26.7C18.2888 33 20.6888 37.7 20.8888 38.1C21.0888 38.5 21.3888 38.7 21.7888 38.7H33.5888C34.3888 38.7 34.7888 37.9 34.4888 37.2C34.4888 37.2 18.5888 5.4 18.1888 4.6C17.8888 3.8 16.8888 3.8 16.4888 4.6Z"
        fill="white"
      />
      <path
        d="M155.049 18.1101C155.049 22.3111 156.998 25.6461 164.621 27.1181C169.169 28.0711 170.121 28.8071 170.121 30.3231C170.121 31.7961 169.168 32.7481 165.963 32.7481C162.238 32.7481 157.821 31.4921 154.919 29.7601V36.6031C157.214 37.7291 160.246 38.9851 165.876 38.9851C173.845 38.9851 177.007 35.4341 177.007 30.1501M177.007 30.1501C177.007 25.1691 174.365 22.8311 166.916 21.2281C162.802 20.3181 161.805 19.4091 161.805 18.1101C161.805 16.4641 163.278 15.7711 166.006 15.7711C169.298 15.7711 172.546 16.7671 175.621 18.1531V11.6131C173.455 10.5301 170.121 9.66406 166.223 9.66406C158.86 9.66406 155.049 12.8691 155.049 18.1091"
        fill="white"
      />
      <path
        d="M257.429 10.0972V38.5522H263.492V16.8542L266.047 22.6142L274.623 38.5522H282.245V10.0972H276.182V28.4612L273.886 23.1342L267 10.0972H257.429Z"
        fill="white"
      />
      <path
        d="M218.863 10.0972H212.237V38.5522H218.863V10.0972Z"
        fill="white"
      />
      <path
        d="M204.592 30.1501C204.592 25.1691 201.95 22.8311 194.501 21.2281C190.387 20.3181 189.39 19.4091 189.39 18.1101C189.39 16.4641 190.863 15.7711 193.591 15.7711C196.883 15.7711 200.131 16.7671 203.206 18.1531V11.6131C201.04 10.5301 197.706 9.66406 193.808 9.66406C186.445 9.66406 182.634 12.8691 182.634 18.1091C182.634 22.3101 184.583 25.6451 192.206 27.1171C196.754 28.0701 197.706 28.8061 197.706 30.3221C197.706 31.7951 196.753 32.7471 193.548 32.7471C189.823 32.7471 185.406 31.4911 182.504 29.7591V36.6021C184.799 37.7281 187.831 38.9841 193.461 38.9841C201.43 38.9841 204.592 35.4341 204.592 30.1501Z"
        fill="white"
      />
      <path
        d="M103.572 10.0972V38.5522H117.192L119.336 32.4022H110.242V10.0972H103.572Z"
        fill="white"
      />
      <path
        d="M76.663 10.0972V16.2472H84.025V38.5522H90.695V16.2472H98.578V10.0972H76.663Z"
        fill="white"
      />
      <path
        d="M66.991 10.0972H58.251L48.329 38.5522H55.908L57.315 33.7602C58.999 34.2532 60.778 34.5232 62.621 34.5232C64.464 34.5232 66.244 34.2542 67.927 33.7602L69.334 38.5522H76.913L66.991 10.0972ZM62.621 28.6302C61.354 28.6302 60.131 28.4452 58.974 28.1062L62.621 15.6842L66.268 28.1062C65.111 28.4452 63.888 28.6302 62.621 28.6302Z"
        fill="white"
      />
      <path
        d="M140.673 10.0972H131.933L122.011 38.5522H129.59L130.997 33.7602C132.681 34.2532 134.46 34.5232 136.303 34.5232C138.146 34.5232 139.926 34.2542 141.609 33.7602L143.016 38.5522H150.595L140.673 10.0972ZM136.303 28.6302C135.036 28.6302 133.813 28.4452 132.656 28.1062L136.303 15.6842L139.95 28.1062C138.793 28.4452 137.57 28.6302 136.303 28.6302Z"
        fill="white"
      />
      <path
        d="M242.742 10.0972H234.002L224.08 38.5522H231.659L233.066 33.7602C234.75 34.2532 236.529 34.5232 238.372 34.5232C240.215 34.5232 241.995 34.2542 243.678 33.7602L245.085 38.5522H252.664L242.742 10.0972ZM238.372 28.6302C237.105 28.6302 235.882 28.4452 234.725 28.1062L238.372 15.6842L242.019 28.1062C240.862 28.4452 239.639 28.6302 238.372 28.6302Z"
        fill="white"
      />
      <path
        d="M303.183 31.662L300.624 38.547H295.925L307.974 7.98096H313.278L325.327 38.547H320.628L318.069 31.615C315.324 32.174 312.952 32.453 310.486 32.453C308.16 32.453 305.787 32.174 303.181 31.662H303.183ZM316.815 28.126L310.627 11.377L304.439 28.173C306.719 28.545 308.626 28.731 310.487 28.731C312.441 28.731 314.442 28.499 316.814 28.127L316.815 28.126Z"
        fill="white"
      />
      <path
        d="M343.894 34.36C342.405 37.43 339.614 39.012 336.031 39.012C329.843 39.012 326.726 33.755 326.726 26.915C326.726 20.355 329.983 14.819 336.496 14.819C339.892 14.819 342.497 16.354 343.893 19.378V5.56201H347.894V38.547H343.893V34.36H343.894ZM337.102 35.291C340.684 35.291 343.894 33.011 343.894 27.847V25.987C343.894 20.823 340.963 18.543 337.566 18.543C333.053 18.543 330.727 21.521 330.727 26.917C330.727 32.5 332.96 35.292 337.101 35.292L337.102 35.291Z"
        fill="white"
      />
      <path
        d="M373.717 38.5468H369.716V24.4968C369.716 20.3098 368.041 18.4488 364.226 18.4488C360.504 18.4488 357.945 20.9148 357.945 25.6128V38.5468H353.944V15.2848H357.945V19.0998C359.434 16.3548 362.179 14.8198 365.296 14.8198C369.251 14.8198 371.949 16.8198 373.112 20.4958C374.415 16.9138 377.532 14.8198 381.393 14.8198C386.604 14.8198 389.488 18.3548 389.488 24.9158V38.5468H385.487V25.6128C385.487 20.8218 383.812 18.4488 379.997 18.4488C376.275 18.4488 373.716 20.9148 373.716 25.6128V38.5468H373.717Z"
        fill="white"
      />
      <path
        d="M397.121 6.35303C398.749 6.35303 399.913 7.37603 399.913 9.14503C399.913 10.914 398.749 11.936 397.121 11.936C395.493 11.936 394.329 10.913 394.329 9.14503C394.329 7.37703 395.492 6.35303 397.121 6.35303ZM395.074 15.286H399.075V38.548H395.074V15.285V15.286Z"
        fill="white"
      />
      <path
        d="M424.896 38.5468H420.895V24.4968C420.895 20.3098 419.22 18.4488 415.405 18.4488C411.683 18.4488 409.124 20.9148 409.124 25.6128V38.5468H405.123V15.2848H409.124V19.0998C410.613 16.3548 413.358 14.8198 416.475 14.8198C421.825 14.8198 424.896 18.4958 424.896 24.9158V38.5468Z"
        fill="white"
      />
      <path
        d="M432.528 6.35303C434.156 6.35303 435.32 7.37603 435.32 9.14503C435.32 10.914 434.157 11.936 432.528 11.936C430.899 11.936 429.736 10.913 429.736 9.14503C429.736 7.37703 430.899 6.35303 432.528 6.35303ZM430.481 15.286H434.482V38.548H430.481V15.285V15.286Z"
        fill="white"
      />
      <path
        d="M447.834 39.0128C444.345 39.0128 441.507 38.2218 439.739 37.2908V33.0578C441.739 34.2208 445.089 35.3368 448.02 35.3368C451.09 35.3368 452.672 34.0808 452.672 32.2668C452.672 30.4988 451.323 29.4748 446.903 28.4058C441.739 27.1488 439.552 25.1488 439.552 21.3348C439.552 17.2868 442.669 14.8208 447.973 14.8208C450.997 14.8208 453.742 15.5648 455.464 16.4958V20.6368C452.672 19.2408 450.393 18.4968 447.927 18.4968C444.996 18.4968 443.414 19.5198 443.414 21.3348C443.414 22.9628 444.53 23.9858 448.81 25.0098C453.975 26.2668 456.58 28.1738 456.58 32.2218C456.58 36.0828 454.068 39.0138 447.833 39.0138L447.834 39.0128Z"
        fill="white"
      />
      <path
        d="M470.399 34.779C471.33 34.779 472.213 34.592 472.911 34.453V38.314C472.213 38.501 471.422 38.687 470.213 38.687C465.235 38.687 462.816 35.7551 462.816 31.4291V19.0071H459.047V15.2841H462.816V10.3521H466.724V15.2841H472.912V19.0071H466.724V31.335C466.724 33.382 467.933 34.779 470.399 34.779Z"
        fill="white"
      />
      <path
        d="M481.938 38.5471H478.03V15.2851H481.938V19.3791C483.287 16.6351 485.613 14.6811 490.173 14.9601V18.8671C485.055 18.3551 481.938 19.8901 481.938 24.8221V38.5471Z"
        fill="white"
      />
      <path
        d="M508.923 34.3598C507.434 37.4298 504.643 39.0118 501.06 39.0118C494.872 39.0118 491.755 33.7548 491.755 26.9148C491.755 20.3548 495.012 14.8188 501.525 14.8188C504.921 14.8188 507.526 16.3538 508.922 19.3778V15.2838H512.923V38.5458H508.922V34.3588L508.923 34.3598ZM502.131 35.2908C505.713 35.2908 508.923 33.0108 508.923 27.8468V25.9868C508.923 20.8228 505.992 18.5428 502.595 18.5428C498.082 18.5428 495.756 21.5208 495.756 26.9168C495.756 32.4998 497.989 35.2918 502.13 35.2918L502.131 35.2908Z"
        fill="white"
      />
      <path
        d="M528.186 34.779C529.117 34.779 530 34.592 530.698 34.453V38.314C530 38.501 529.209 38.687 528 38.687C523.022 38.687 520.603 35.7551 520.603 31.4291V19.0071H516.834V15.2841H520.603V10.3521H524.511V15.2841H530.699V19.0071H524.511V31.335C524.511 33.382 525.72 34.779 528.186 34.779Z"
        fill="white"
      />
      <path
        d="M537.864 6.35303C539.492 6.35303 540.656 7.37603 540.656 9.14503C540.656 10.914 539.492 11.936 537.864 11.936C536.236 11.936 535.072 10.913 535.072 9.14503C535.072 7.37703 536.235 6.35303 537.864 6.35303ZM535.817 15.286H539.818V38.548H535.817V15.285V15.286Z"
        fill="white"
      />
      <path
        d="M544.471 26.8698C544.471 19.8908 548.565 14.8198 555.544 14.8198C562.476 14.8198 566.523 19.8898 566.523 26.8698C566.523 33.8498 562.476 39.0128 555.544 39.0128C548.565 39.0128 544.471 33.8488 544.471 26.8698ZM548.379 26.8698C548.379 31.2888 550.566 35.2908 555.544 35.2908C560.476 35.2908 562.616 31.2888 562.616 26.8698C562.616 22.4508 560.476 18.5418 555.544 18.5418C550.566 18.5418 548.379 22.4498 548.379 26.8698Z"
        fill="white"
      />
      <path
        d="M590.95 38.5468H586.949V24.4968C586.949 20.3098 585.274 18.4488 581.459 18.4488C577.737 18.4488 575.178 20.9148 575.178 25.6128V38.5468H571.177V15.2848H575.178V19.0998C576.667 16.3548 579.412 14.8198 582.529 14.8198C587.879 14.8198 590.95 18.4958 590.95 24.9158V38.5468Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2305_6798"
        x1="14.9049"
        y1="22.6043"
        x2="5.94989"
        y2="38.1143"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="0.923" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_2305_6798">
        <rect width="591" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
